import { Button, Tooltip } from "@kyan/ui";
import React from "react";

import { useMintUSDC } from "#/hooks/useMintUSDC";

export const MintButton: React.FC = () => {
  const { mint, canMint, isLoading, isDisabled } = useMintUSDC();
  return (
    <Tooltip
      side="bottom"
      disabled={canMint}
      content="You can only mint once per day"
    >
      <Button
        size="sm"
        disabled={isDisabled}
        isLoading={isLoading}
        className="shadow-none"
        onClick={() => mint("120000")}
      >
        Mint mockUSDC
      </Button>
    </Tooltip>
  );
};
